var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserNetworkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333496,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FF627D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 7.66675C11.65 7.66675 9.875 9.44175 9.875 11.6251C9.875 13.7667 11.55 15.5001 13.7333 15.5751C13.8 15.5667 13.8667 15.5667 13.9167 15.5751C13.9333 15.5751 13.9417 15.5751 13.9583 15.5751C13.9667 15.5751 13.9667 15.5751 13.975 15.5751C16.1083 15.5001 17.7833 13.7667 17.7917 11.6251C17.7917 9.44175 16.0167 7.66675 13.8333 7.66675Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0668 17.7917C15.7418 16.2417 11.9501 16.2417 9.60846 17.7917C8.55013 18.5 7.9668 19.4583 7.9668 20.4833C7.9668 21.5083 8.55013 22.4583 9.60013 23.1583C10.7668 23.9417 12.3001 24.3333 13.8335 24.3333C15.3668 24.3333 16.9001 23.9417 18.0668 23.1583C19.1168 22.45 19.7001 21.5 19.7001 20.4667C19.6918 19.4417 19.1168 18.4917 18.0668 17.7917Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9918 12.1166C23.1251 13.7333 21.9751 15.1499 20.3835 15.3416C20.3751 15.3416 20.3751 15.3416 20.3668 15.3416H20.3418C20.2918 15.3416 20.2418 15.3416 20.2001 15.3583C19.3918 15.3999 18.6501 15.1416 18.0918 14.6666C18.9501 13.8999 19.4418 12.7499 19.3418 11.4999C19.2835 10.8249 19.0501 10.2083 18.7001 9.68325C19.0168 9.52492 19.3835 9.42492 19.7585 9.39159C21.3918 9.24992 22.8501 10.4666 22.9918 12.1166Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6589 19.8249C24.5922 20.6333 24.0755 21.3333 23.2089 21.8083C22.3755 22.2666 21.3255 22.4833 20.2839 22.4583C20.8839 21.9166 21.2339 21.2416 21.3005 20.5249C21.3839 19.4916 20.8922 18.4999 19.9089 17.7083C19.3505 17.2666 18.7005 16.9166 17.9922 16.6583C19.8339 16.1249 22.1505 16.4833 23.5755 17.6333C24.3422 18.2499 24.7339 19.0249 24.6589 19.8249Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNetworkIcon);
export default __webpack_public_path__ + "static/media/user-network-icon.419b1bb29e3ca0e05ac935a0574a705b.svg";
export { ForwardRef as ReactComponent };